import React, { useState, useEffect } from "react";
import { fetchBitcoinPrice, fetchRecommendedFees } from "../api/Bitcoin";
import "./Footer.css";

function Footer() {
	const [price, setPrice] = useState(null);
	const [fees, setFees] = useState(null);
	const [error, setError] = useState("");
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		async function loadBitcoinData() {
			try {
				const [priceData, feeData] = await Promise.all([
					fetchBitcoinPrice(),
					fetchRecommendedFees(),
				]);
				setPrice(priceData);
				setFees(feeData);
			} catch (err) {
				setError(err.message);
			} finally {
				setLoading(false);
			}
		}

		loadBitcoinData();
	}, []);
	if (loading) return <div className="footer-container">Loading...</div>;

	return (
		<div className="footer-container">
			<div>
				<div className="bitcoin-price-info">
					{error && <div>Error: {error}</div>}
					{price && price.prices && price.prices.USD && (
						<div>Price: {price.prices.USD} USD</div>
					)}
					{fees && (
						<div>
							<p>Fastest Fee: {fees.fastestFee}</p>
							<p>Economy Fee: {fees.economyFee}</p>
						</div>
					)}
				</div>
			</div>
		</div>
	);
}

export default Footer;
